import React, { useCallback } from 'react';
import styled from 'astroturf/react';
import { Icon } from 'js/design_system/Icon';

const StyledButton = styled.button`
  background: none;
  border: none;
  padding: 14px;
  position: absolute;
  top: 12px;
  left: 26px;
  cursor: pointer;
  color: var(--text-primary, #141413);

  &:hover,
  &:focus {
    color: var(--hover, #0c3b8d);
  }

  &:active {
    color: var(--button-secondary-text-press, #082f75);
  }

  &:focus:not(:active) {
    outline: 2px solid var(--buttons-button-focus, #0645b1);
    text-decoration: none;

    &:not(:focus-visible) {
      outline: none;
    }
  }
`;

type Props = {
  onClick: () => void;
};

export const BackButton: React.FC<Props> = ({ onClick }) => {
  const handleClick = useCallback(
    async (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
      e.preventDefault();
      onClick();
    },
    [onClick],
  );

  return (
    <StyledButton onClick={handleClick} aria-label="Back" type="button">
      <Icon name="arrow_back" size={24} />
    </StyledButton>
  );
};
